import en from './en.json'
import zh from './zh.json'
import ar from './ar.json'
import ja from './ja.json'

export default {
  en,
  zh,
  ar,
  ja
}